<template>
  <absolutely-layout :enable-scroll-event="true" :show-footer="false">
    <div
      class="relative w-full min-h-screen bg-gradient-to-t from-[#6bc6ef] via-[#5ab8e0] to-[#4aa3d0]"
    >
      <!-- Sea Background - dynamically renders all homepage images, each 100vh -->
      <div class="absolute bottom-0 left-0 right-0 w-full h-auto flex flex-col-reverse z-0">
        <!-- <OceanNoiseRipple
          :image="'/assets/absolutely/homepage/ocean-noise.webp'"
          class="pointer-events-none absolute inset-0 w-full h-full z-10 select-none"
        /> -->
        <div v-for="img in homepageImages" :key="img" class="relative w-full h-screen">
          <img
            :src="img"
            alt="Sea background section"
            draggable="false"
            class="w-full h-full object-cover select-none pointer-events-none object-fill"
          />
        </div>
      </div>

      <!-- Ship at selected Episode -->
      <div
        ref="ship"
        class="absolute z-30 w-[175px] transition-transform"
        :class="isShipAtIsland ? 'cursor-pointer active:scale-95' : ''"
        :style="shipPosition"
        @click="isShipAtIsland ? handleShipClick() : null"
      >
        <img
          src="/assets/absolutely/homepage/ship.png"
          alt="Ship"
          class="h-auto w-full select-none pointer-events-none"
          draggable="false"
        />
      </div>

      <!-- Top Left Button: HOGC Home -->
      <div class="fixed top-[24px] left-[24px] z-30" :class="{ 'pt-[32px]': isIos() }">
        <button
          class="flex items-center justify-center transition-transform active:scale-95 focus:outline-none w-[18vw] max-w-[80px] aspect-square"
          @click="handleHogcHomeClick"
        >
          <img
            src="/assets/absolutely/hogc-home-button.png"
            alt="HOGC Home"
            class="w-full h-full object-contain select-none pointer-events-none"
            draggable="false"
          />
        </button>
      </div>

      <!-- Floating Bottom Buttons: Guide and Menu -->
      <!-- <div
        class="fixed bottom-0 left-0 right-0 flex items-center justify-center gap-[64px] z-30"
        :class="{ 'pb-[34px]': isIos(), 'pb-[24px]': !isIos() }"
      > -->
      <!-- Menu Button -->
      <!-- <div class="flex flex-col items-center">
          <button
            class="flex items-center justify-center transition-transform active:scale-95 focus:outline-none w-[18vw] max-w-[80px] aspect-square"
            @click="handleMenuClick"
          >
            <img
              src="/assets/absolutely/menu-button.png"
              alt="Menu"
              class="w-full h-full object-contain select-none pointer-events-none"
              draggable="false"
            />
          </button>
          <div
            class="text-[5vw] leading-[1.2] font-a-big-deal text-[#59173E] font-normal mt-[8px] cursor-pointer transition-transform active:scale-95"
            @click="handleMenuClick"
          >
            MENU
          </div>
        </div> -->
      <!-- </div> -->

      <!-- Content Container - extends upward from bottom -->
      <div class="relative z-10 min-h-[200vh] flex flex-col justify-end pb-[400px]">
        <!-- Dotted Sinusoidal Wave Path -->
        <svg
          class="absolute left-0 bottom-[200px] w-full pointer-events-none z-10"
          :style="{ height: `${(getChapters.length + 1) * chapterVerticalSpacing}px` }"
        >
          <!-- Wave connecting islands -->
          <path
            v-if="getChapters.length >= 1"
            :d="generateWavePath()"
            stroke="white"
            stroke-width="8"
            fill="none"
            stroke-dasharray="12,12"
            stroke-linecap="round"
            opacity="1"
          />
        </svg>
        <!-- Episode Islands-->
        <div
          v-for="(chapter, idx) in getChapters"
          :key="chapter.id"
          class="absolute flex justify-center w-full z-20"
          :style="{ bottom: `${(idx + 1) * chapterVerticalSpacing + 180}px` }"
          @click="selectChapter(idx + 1)"
        >
          <div
            :class="[
              'transition-transform duration-300',
              idx % 2 === 0
                ? 'translate-x-[18%] md:translate-x-[18%]'
                : '-translate-x-[18%] md:-translate-x-[18%]',
              'flex justify-center w-full',
            ]"
            style="will-change: transform"
          >
            <img
              :src="chapterImages[idx]"
              :alt="chapter.chapterName"
              class="w-[65vw] max-w-[300px]"
            />
            <!-- Left Cloud -->
            <!-- Temporarily hidden -->
            <!--
            <img
              :key="`cloud-left-${idx}-${cloudAnimationKey}`"
              src="/assets/absolutely/homepage/cloud.webp"
              :class="[
                'absolute opacity-80 w-[180px] cloud-wiggle transition-[left] duration-400 ease-in-out',
                selectedChapterId === idx + 1 ? 'left-[0px] delay-700' : 'left-[80px] delay-0',
              ]"
            />
            -->
            <!-- Right Cloud -->
            <!-- Temporarily hidden -->
            <!--
            <img
              :key="`cloud-right-${idx}-${cloudAnimationKey}`"
              src="/assets/absolutely/homepage/cloud.webp"
              :class="[
                'absolute opacity-80 w-[180px] bottom-[10px] cloud-wiggle-inverse transition-[right] duration-400 ease-in-out',
                selectedChapterId === idx + 1 ? 'right-[0px] delay-700' : 'right-[80px] delay-0',
              ]"
            />
            -->
          </div>
        </div>
      </div>
    </div>
    <!-- Episode Confirm Popup -->
    <transition
      enter-active-class="transition ease-out duration-300"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition ease-in duration-250"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="isChapterPopupVisible"
        class="fixed bottom-[28px] left-[45px] right-[45px] pointer-events-auto z-50"
      >
        <ChapterConfirmPopup
          button-label="EXPLORE"
          :title="`Episode ${selectedChapterId}:`"
          :subtitle="selectedChapterTitle"
          :selected-chapter-id="selectedChapterId"
          class="h-[164px]"
          @close="closeChapterConfirmPopup"
        ></ChapterConfirmPopup>
      </div>
    </transition>

    <!-- Episode List Popup -->
    <ChapterListPopup v-model="showChapterPopup" />
  </absolutely-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { get } from 'lodash';
import { gsap } from '../../libraries/gsap';
// Orientation is handled by router guards

import AnimatedButton from '@/components/Absolutely/AnimatedButton.vue';
import ChapterListPopup from '@/components/Absolutely/ChapterListPopup.vue';
import { isIosNativeOnly } from '@/utils/platform-check';
import ChapterConfirmPopup from '@/components/Absolutely/ChapterConfirmPopup.vue';
import OceanNoiseRipple from '@/components/Absolutely/OceanNoiseRipple.vue';
import { SHIP_AT_ISLAND_THRESHOLD, SHIP_POSITION_OFFSET } from '@/constants/absolutely';

import AbsolutelyAccessMixin from '@/mixins/AbsolutelyAccess';

export default {
  name: 'AbsolutelyHome',
  mixins: [AbsolutelyAccessMixin],
  components: { AnimatedButton, ChapterListPopup, ChapterConfirmPopup, OceanNoiseRipple },
  data() {
    return {
      resizeObserver: null,
      homepageImages: [],
      chapterImages: [],
      showChapterPopup: false,
      chapterVerticalSpacing: typeof window !== 'undefined' ? window.innerHeight * 0.45 : 400,
      shipParametric: null, // Will be initialized based on current chapter progress
      showChapterConfirmPopup: false,
      showChapterConfirmPopupVisible: false,
      chapterConfirmTimeout: null,
      cloudAnimationKey: 0, // Key to force restart cloud animations
    };
  },
  computed: {
    ...mapGetters('absolutely', [
      'isChapterUnlocked',
      'getChapters',
      'getTitleById',
      'getCurrentChapterId',
      'getTotalSteps',
      'getCompletedStepsCount',
      'getSelectedChapterId',
      'hasVisitedAbsolutely',
    ]),
    selectedChapterId() {
      return this.getSelectedChapterId;
    },
    isChapter1Unlocked() {
      return this.isChapterUnlocked(1);
    },
    isChapter2Unlocked() {
      return this.isChapterUnlocked(2);
    },
    selectedChapterTitle() {
      if (this.selectedChapterId === null) return '';
      return this.getTitleById(this.selectedChapterId);
    },
    // Calculate current chapter based on progress
    // Returns the highest unlocked chapter that hasn't been fully completed
    // If all unlocked chapters are completed, returns the highest unlocked chapter
    currentChapterId() {
      // getCurrentChapterId already returns the first chapter that is NOT completed
      // So we can just use it directly without additional checks
      const currentChapter = this.getCurrentChapterId;
      console.log('[currentChapterId computed] getCurrentChapterId:', currentChapter);
      return currentChapter || 1;
    },
    shipPosition() {
      // Calculate ship position based on shipParametric value
      // If shipParametric is null, use current chapter to initialize
      const parametric =
        this.shipParametric !== null
          ? this.shipParametric
          : Math.max(0, this.currentChapterId - SHIP_POSITION_OFFSET);
      const pos = this.calculateShipPosition(parametric);
      return {
        left: `${pos.x}px`,
        bottom: `${pos.y}px`,
        transform: 'translate(-50%, 0)',
      };
    },
    // Check if ship is currently at an island (not in transit)
    isShipAtIsland() {
      if (this.shipParametric === null) return false;

      // Check if ship is close to any island position
      // Islands are at positions: 1-SHIP_POSITION_OFFSET, 2-SHIP_POSITION_OFFSET, etc.
      const shipPos = this.shipParametric;

      // Check each chapter position
      for (let chapterId = 1; chapterId <= this.getChapters.length; chapterId++) {
        const islandPosition = chapterId - SHIP_POSITION_OFFSET;
        const distance = Math.abs(shipPos - islandPosition);
        if (distance < SHIP_AT_ISLAND_THRESHOLD) {
          return true; // Ship is at an island
        }
      }

      return false; // Ship is in transit
    },
    // Get the chapter ID that the ship is currently at
    shipCurrentChapterId() {
      if (this.shipParametric === null) return null;

      const shipPos = this.shipParametric;

      // Find which island the ship is closest to
      for (let chapterId = 1; chapterId <= this.getChapters.length; chapterId++) {
        const islandPosition = chapterId - SHIP_POSITION_OFFSET;
        const distance = Math.abs(shipPos - islandPosition);
        if (distance < SHIP_AT_ISLAND_THRESHOLD) {
          return chapterId;
        }
      }

      return null; // Ship is not at any island
    },
    // Computed property to check if popup is visible
    isChapterPopupVisible() {
      return this.showChapterConfirmPopup && this.showChapterConfirmPopupVisible;
    },
  },
  methods: {
    ...mapActions('absolutely', [
      'setSelectedChapterId',
      'syncOnboarding',
      'loadProgress',
      'fetchContent',
    ]),
    handleResize() {
      this.chapterVerticalSpacing = window.innerHeight * 0.45;
    },
    generateWavePath() {
      const numChapters = this.getChapters.length;
      if (numChapters < 1) return '';

      // Vertical spacing between chapters
      const verticalSpacing = this.chapterVerticalSpacing;

      // Viewport width to calculate horizontal positions
      const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 375;
      const centerX = viewportWidth / 2;

      // Amplitude: 15% of viewport width (chapters offset by ±15%)
      const amplitude = viewportWidth * 0.15;

      // Add one extra spacing for "island 0" to island 1
      const svgHeight = this.chapterVerticalSpacing * (numChapters + 1);

      let path = '';

      // Start from idx = -1 (island 0) and draw up to last island
      // idx = -1: island 0 (imaginary start point)
      // idx = 0: island 1, idx = 1: island 2, etc.
      for (let idx = -1; idx < numChapters; idx++) {
        const currentX = idx % 2 === 0 ? centerX + amplitude : centerX - amplitude;
        const currentY = svgHeight - (idx + 1) * verticalSpacing;

        if (idx === -1) {
          // Start of path at island 0
          path = `M ${currentX} ${currentY}`;
        } else {
          // Draw curve from previous island to current island
          const prevIdx = idx - 1;
          const prevX = prevIdx % 2 === 0 ? centerX + amplitude : centerX - amplitude;
          const prevY = svgHeight - (prevIdx + 1) * verticalSpacing;

          // Create smooth sinusoidal curve using cubic Bezier
          const controlPointOffset = verticalSpacing / 2;

          // Control points for smooth S-curve
          const cp1X = prevX;
          const cp1Y = prevY - controlPointOffset; // Moving upward (decreasing Y)
          const cp2X = currentX;
          const cp2Y = currentY + controlPointOffset; // Approaching from below

          path += ` C ${cp1X} ${cp1Y}, ${cp2X} ${cp2Y}, ${currentX} ${currentY}`;
        }
      }

      return path;
    },
    loadChapterImages() {
      const base = '/assets/absolutely/homepage/island-';
      // List all chapter images (update if more chapters are added)
      this.chapterImages = this.getChapters.map(chapter => `${base}${chapter.id}.webp`);
    },
    loadHomepageImages() {
      const base = '/assets/absolutely/homepage/';
      // List all images in the folder (update if more images are added)
      const files = ['homepage1.png', 'homepage2.png'];
      this.homepageImages = files.map(f => base + f);
    },
    async preloadImages() {
      // Preload all images to prevent flicker during fade transition
      const allImages = [...this.homepageImages, ...this.chapterImages];

      // Also preload button images
      const buttonImages = [
        '/assets/absolutely/hogc-home-button.png',
        '/assets/absolutely/guide-button.png',
        '/assets/absolutely/menu-button.png',
        '/assets/absolutely/homepage/ship.png',
      ];

      const allImagesToPreload = [...allImages, ...buttonImages];

      // Preload all images
      const preloadPromises = allImagesToPreload.map(src => {
        return new Promise(resolve => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = resolve; // Resolve even on error to not block
          img.src = src;
        });
      });

      await Promise.allSettled(preloadPromises);
    },
    calculateShipPosition(t) {
      // t = parametric value: 0.0 at island 0, 0.5 between islands, 1.0 at island 1, etc.
      const numChapters = this.getChapters.length;
      if (numChapters < 1) return { x: 0, y: 0 };

      const verticalSpacing = this.chapterVerticalSpacing;
      const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 375;
      const centerX = viewportWidth / 2;
      const amplitude = viewportWidth * 0.15;

      // Calculate which segment we're in
      const totalSegments = numChapters; // island 0->1, 1->2, 2->3, etc.
      const clampedT = Math.max(0, Math.min(t, totalSegments));
      const segmentIndex = Math.floor(clampedT);
      const segmentProgress = clampedT - segmentIndex; // 0 to 1 within segment

      // Vertical position interpolation
      const baseY = 180; // Base offset
      const startY = baseY + segmentIndex * verticalSpacing;
      const endY = baseY + (segmentIndex + 1) * verticalSpacing;
      const y = startY + (endY - startY) * segmentProgress;

      // Horizontal position: sine wave interpolation
      const startIdx = segmentIndex - 1; // island 0 is index -1
      const endIdx = segmentIndex; // next island
      const startX = startIdx % 2 === 0 ? centerX + amplitude : centerX - amplitude;
      const endX = endIdx % 2 === 0 ? centerX + amplitude : centerX - amplitude;

      // Smooth sinusoidal interpolation
      const sineProgress = Math.sin((segmentProgress * Math.PI) / 2);
      const x = startX + (endX - startX) * sineProgress;

      return { x, y };
    },
    animateShipToChapter(chapterId, onCompleteCallback) {
      // Animate ship parametrically to target chapter
      const targetT = chapterId; // 0.0 = island 0, 1.0 = island 1, etc.
      const targetPosition = targetT - SHIP_POSITION_OFFSET;
      console.log(
        '[animateShipToChapter] Called with chapterId:',
        chapterId,
        'will animate to position:',
        targetPosition,
      );

      gsap.to(this, {
        shipParametric: targetPosition, //slightly before island to not cover island titles
        duration: 1.2,
        ease: 'power2.inOut',
        onUpdate: () => {
          // Position updates automatically via computed property
        },
        onComplete: () => {
          // Call optional callback if provided
          if (onCompleteCallback && typeof onCompleteCallback === 'function') {
            onCompleteCallback();
          }
        },
      });
    },
    async selectChapter(chapterId) {
      // If popup is already open for this chapter, don't close and reopen it
      if (this.selectedChapterId === chapterId && this.isChapterPopupVisible) {
        // Popup already open for this chapter - just scroll to it
        await this.scrollToChapter(chapterId);
        return;
      }

      // If clicking a different island, close current popup first
      if (this.selectedChapterId !== chapterId && this.isChapterPopupVisible) {
        this.hideChapterConfirmPopup();
        // Wait a bit for popup to close before opening new one
        await new Promise(resolve => setTimeout(resolve, 250));
      }

      this.setSelectedChapterId(chapterId);

      // Check if ship is already at this chapter (within small threshold)
      const currentShipPosition = this.shipParametric ?? 0;
      const targetPosition = chapterId - SHIP_POSITION_OFFSET;
      const distance = Math.abs(currentShipPosition - targetPosition);
      const isShipAlreadyThere = distance < SHIP_AT_ISLAND_THRESHOLD; // Same threshold as ship click detection

      console.log('[selectChapter] Ship position check:', {
        chapterId,
        currentShipPosition,
        targetPosition,
        distance,
        isShipAlreadyThere,
      });

      // Reset popup flags to ensure it can show again
      // Clear any existing timeout
      if (this.chapterConfirmTimeout) {
        clearTimeout(this.chapterConfirmTimeout);
        this.chapterConfirmTimeout = null;
      }
      // Reset flags immediately
      this.showChapterConfirmPopup = false;
      this.showChapterConfirmPopupVisible = false;

      // If ship is already there, show popup immediately
      // Otherwise, show popup after ship animation completes
      if (isShipAlreadyThere) {
        // Ship already at island - show popup immediately
        this.showChapterConfirmPopupAnimate(chapterId);
      } else {
        // Ship needs to move - show popup after animation
        this.animateShipToChapter(chapterId, () => {
          // Show popup after ship animation completes
          this.showChapterConfirmPopupAnimate(chapterId);
        });
      }

      // Scroll to center the selected chapter
      await this.scrollToChapter(chapterId);
    },
    handleShipClick() {
      // Only works when ship is at an island
      if (!this.isShipAtIsland) return;

      // Get the chapter ID that the ship is currently at
      const chapterAtShip = this.shipCurrentChapterId;
      if (chapterAtShip) {
        // Open popup for the island the ship is at
        this.selectChapter(chapterAtShip);
      }
    },
    closeChapterConfirmPopup() {
      this.hideChapterConfirmPopup();
    },
    // Unified function to show chapter confirm popup
    showChapterConfirmPopupAnimate(chapterId) {
      if (this.isComingSoon(chapterId)) return;

      // Clear any existing timeout
      if (this.chapterConfirmTimeout) {
        clearTimeout(this.chapterConfirmTimeout);
        this.chapterConfirmTimeout = null;
      }

      // Set popup to exist in DOM
      this.showChapterConfirmPopup = true;
      // After delay, make it visible (triggers transition)
      this.chapterConfirmTimeout = setTimeout(() => {
        this.showChapterConfirmPopupVisible = true;
      }, 250);
    },
    // Unified function to hide chapter confirm popup
    hideChapterConfirmPopup() {
      // Clear any existing timeout
      if (this.chapterConfirmTimeout) {
        clearTimeout(this.chapterConfirmTimeout);
        this.chapterConfirmTimeout = null;
      }

      // Animated hide - start transition, then remove from DOM
      this.showChapterConfirmPopupVisible = false;
      // Wait for fade-out transition to complete before removing from DOM
      setTimeout(() => {
        this.showChapterConfirmPopup = false;
        // Restart cloud animations by changing key (forces re-render and restarts CSS animations)
        // This fixes the issue where animations stop on native platforms after returning from popup
        this.restartCloudAnimations();
      }, 250); // Match leave transition duration
    },
    restartCloudAnimations() {
      // Increment key to force Vue to re-render cloud elements and restart CSS animations
      // This is necessary on native platforms where animations can pause when returning from modals
      this.cloudAnimationKey += 1;
      // Force a reflow to ensure animations restart
      this.$nextTick(() => {
        // Trigger reflow by accessing offsetHeight
        const clouds = this.$el?.querySelectorAll('.cloud-wiggle, .cloud-wiggle-inverse');
        if (clouds && clouds.length > 0) {
          clouds[0].offsetHeight; // Force reflow
        }
      });
    },
    calculateChapterScrollPosition(chapterId) {
      // Calculate scroll position without needing DOM access
      // This can be called early before DOM is ready
      const chapterBottomOffset = chapterId * this.chapterVerticalSpacing + 180;
      // We'll need to get actual scrollHeight/clientHeight when DOM is ready
      // but this gives us the offset calculation
      return chapterBottomOffset;
    },
    async setScrollPositionInstantly(chapterId) {
      // Set scroll position instantly without animation - for prescrolling
      const ionPage = this.$el?.closest('ion-page') || this.$el;
      const ionContent = ionPage?.querySelector('ion-content');

      if (!ionContent) {
        return false;
      }

      try {
        const scrollElement = await ionContent.getScrollElement();

        // Calculate the chapter's position from the bottom
        const chapterBottomOffset = chapterId * this.chapterVerticalSpacing + 180;

        // Get scroll dimensions
        const scrollHeight = scrollElement.scrollHeight;
        const clientHeight = scrollElement.clientHeight;

        // If content isn't loaded yet, scrollHeight might be 0
        if (scrollHeight === 0 || clientHeight === 0) {
          return false;
        }

        // Calculate scroll position to center the chapter
        const targetScrollTop = scrollHeight - chapterBottomOffset - clientHeight / 2;

        // Clamp to valid scroll range
        const maxScroll = scrollHeight - clientHeight;
        const finalScrollTop = Math.max(0, Math.min(targetScrollTop, maxScroll));

        // Set scroll position directly without animation
        scrollElement.scrollTop = finalScrollTop;
        return true;
      } catch (error) {
        console.error('[AbsolutelyHome] Error setting scroll position:', error);
        return false;
      }
    },
    async scrollToChapter(chapterId, behavior = 'smooth') {
      const ionPage = this.$el?.closest('ion-page') || this.$el;
      const ionContent = ionPage?.querySelector('ion-content');

      if (!ionContent) {
        console.warn('[AbsolutelyHome] ion-content not found for scrollToChapter');
        return;
      }

      try {
        const scrollElement = await ionContent.getScrollElement();

        // Calculate the chapter's position from the bottom
        const chapterBottomOffset = chapterId * this.chapterVerticalSpacing + 180;

        // Get scroll dimensions
        const scrollHeight = scrollElement.scrollHeight;
        const clientHeight = scrollElement.clientHeight;

        // Calculate scroll position to center the chapter
        // scrollTop = scrollHeight - chapterBottomOffset - (clientHeight / 2)
        const targetScrollTop = scrollHeight - chapterBottomOffset - clientHeight / 2;

        // Clamp to valid scroll range
        const maxScroll = scrollHeight - clientHeight;
        const finalScrollTop = Math.max(0, Math.min(targetScrollTop, maxScroll));

        scrollElement.scrollTo({
          top: finalScrollTop,
          behavior: behavior,
        });
      } catch (error) {
        console.error('[AbsolutelyHome] Error scrolling to chapter:', error);
      }
    },
    navigateToChapter(chapterId) {
      // Navigate to chapter overview page
      this.$router.push(`/absolutely/chapter/${chapterId}`);
    },
    handleHogcHomeClick() {
      // Navigate to main HOGC home page (directly to tabs/home to avoid redirect issues)
      this.$router.push('/tabs/home');
    },
    handleGuideClick() {
      // Navigate to Parent's guide page
      // this.$router.push('/absolutely/parents-guide');
      // forward to survey for launch 1 for now
      this.$router.push('/forms/absolutely-kids');
    },
    handleMenuClick() {
      // Open chapter list popup
      this.showChapterPopup = true;
    },
    async scrollToTop() {
      const ionPage = this.$el?.closest('ion-page') || this.$el;
      const ionContent = ionPage?.querySelector('ion-content');
      if (ionContent) {
        try {
          const scrollElement = await ionContent.getScrollElement();
          scrollElement.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        } catch (error) {
          console.error('[AbsolutelyHome] Error scrolling to top:', error);
        }
      }
    },
    isIos() {
      return isIosNativeOnly();
    },
    async scrollToBottom() {
      // Find the ion-content element (from EmptyLayout)
      // this.$el is already the ion-page element, so query directly from it
      const ionPage = this.$el?.closest('ion-page') || this.$el;
      const ionContent = ionPage?.querySelector('ion-content');
      console.log('[AbsolutelyHome] Found ion-content:', !!ionContent);

      if (!ionContent) {
        console.warn('[AbsolutelyHome] ion-content not found, trying document.querySelector');
        // Fallback: try to find ion-content in the DOM
        const ionContentAlt = document.querySelector('ion-content');
        console.log(
          '[AbsolutelyHome] Found ion-content via document.querySelector:',
          !!ionContentAlt,
        );
        if (ionContentAlt) {
          await this.scrollIonContent(ionContentAlt);
        }
        return;
      }

      await this.scrollIonContent(ionContent);
    },
    async scrollIonContent(ionContent) {
      try {
        console.log('[AbsolutelyHome] scrollIonContent called');
        const scrollElement = await ionContent.getScrollElement();
        const scrollHeight = scrollElement.scrollHeight;
        const clientHeight = scrollElement.clientHeight;
        const maxScroll = scrollHeight - clientHeight;

        console.log(
          '[AbsolutelyHome] scrollHeight:',
          scrollHeight,
          'clientHeight:',
          clientHeight,
          'maxScroll:',
          maxScroll,
        );

        if (maxScroll > 0) {
          console.log('[AbsolutelyHome] Scrolling to:', maxScroll);
          scrollElement.scrollTo({
            top: maxScroll,
            behavior: 'instant',
          });
        } else {
          // If scroll element doesn't detect content, use Ionic's scrollToBottom method
          await ionContent.scrollToBottom(0);
        }
      } catch (error) {
        console.error('[AbsolutelyHome] Error in scrollIonContent:', error);
        // Fallback to scrollToBottom
        try {
          await ionContent.scrollToBottom(0);
          console.log('[AbsolutelyHome] Fallback scrollToBottom() completed');
        } catch (e) {
          console.error('[AbsolutelyHome] Fallback scrollToBottom() failed:', e);
        }
      }
    },
    isComingSoon(chapterId) {
      if (chapterId === 1) return false;
      if (chapterId === 2 || chapterId === 3) {
        return true;
      }
      return false;
    },
  },
  async ionViewWillEnter() {
    // Check access
    if (!(await this.checkAbsolutelyAccess())) return;

    console.log('[AbsolutelyHome] 🎬 ionViewDidEnter() called');
    // Also log to native Android Logcat
    if (window.Android && window.Android.log) {
      window.Android.log('[AbsolutelyHome] 🎬 ionViewDidEnter() called');
    }
    // Orientation is handled by router guards

    // Ensure images are loaded before proceeding (prevent flicker during fade animation)
    if (this.homepageImages.length === 0) {
      this.loadHomepageImages();
    }

    // Check if content already exists in store to avoid unnecessary refresh
    const hasContent =
      this.$store.state.absolutely.chapters &&
      Object.keys(this.$store.state.absolutely.chapters).length > 0;

    // Fetch content (chapters and milestones) and progress in parallel
    // Only refresh if content doesn't exist to prevent unnecessary API calls and flicker
    await Promise.allSettled([
      this.fetchContent({ refresh: !hasContent }), // Only refresh if no content exists
      this.loadProgress(), // Load user progress
    ]);
    // Wait for Vue to update computed properties after data is loaded
    await this.$nextTick();

    // Load chapter images after chapters are loaded
    if (this.getChapters.length > 0 && this.chapterImages.length === 0) {
      this.loadChapterImages();
    }

    // Preload images to prevent flicker during fade transition
    // This ensures images are ready before the fade animation completes
    await this.preloadImages();

    // Prescroll immediately after data loads to prevent visible jump
    const currentChapterForPrescroll = this.currentChapterId;
    const chapterToPrescroll =
      this.selectedChapterId > 0 ? this.selectedChapterId : currentChapterForPrescroll;
    await this.setScrollPositionInstantly(chapterToPrescroll);

    // Store the ship position to detect changes
    const previousShipParametric = this.shipParametric;

    // Get current chapter after data has loaded
    const currentChapter = this.currentChapterId;

    // Check if we're returning from a completed chapter
    const completedChapterId = parseInt(this.$route.query.completedChapter, 10);
    let targetChapterId = null;

    if (completedChapterId && !isNaN(completedChapterId)) {
      const nextChapterId = completedChapterId + 1;
      // Check if next chapter exists and is unlocked
      if (this.isChapterUnlocked(nextChapterId)) {
        targetChapterId = nextChapterId;
        // Set selected chapter to next chapter first (this triggers cloud animation)
        this.setSelectedChapterId(nextChapterId);
        // Wait for Vue to update the DOM
        await this.$nextTick();

        // Scroll map to next chapter FIRST, then animate ship
        await this.scrollToChapter(nextChapterId, 'smooth');
        // Wait for scroll to complete before animating ship
        await new Promise(resolve => setTimeout(resolve, 500));

        // Animate ship to next chapter after scroll with callback to show popup
        this.animateShipToChapter(nextChapterId, () => {
          // Show popup after ship animation completes (same as selectChapter)
          this.showChapterConfirmPopupAnimate(nextChapterId);
        });
        console.log(
          '[AbsolutelyHome] Returning from completed chapter',
          completedChapterId,
          '- scrolling to next chapter',
          nextChapterId,
          'then animating ship',
        );
        // Restart cloud animations after returning from chapter completion popup
        // This fixes the issue where animations stop on native platforms
        await this.$nextTick();
        this.restartCloudAnimations();
      }
      // Clear the query param to avoid repeating this behavior
      this.$router.replace({ path: '/absolutely/home', query: {} });
    } else {
      // No query param - initialize ship position only on first load
      // Subsequent visits should preserve ship position unless a chapter is completed
      if (this.shipParametric === null) {
        // Ship not positioned yet - initialize it (FIRST LOAD ONLY)
        // Check if this is first visit
        const hasVisitedAbsolutely = this.hasVisitedAbsolutely;
        const onboardingFlags = this.$store.state.absolutely.memberOnboardingFlags;
        const isFirstVisit = !hasVisitedAbsolutely;
        console.log('[AbsolutelyHome] hasVisitedAbsolutely getter:', hasVisitedAbsolutely);
        console.log('[AbsolutelyHome] memberOnboardingFlags state:', onboardingFlags);
        console.log('[AbsolutelyHome] isFirstVisit:', isFirstVisit);
        console.log(
          '[AbsolutelyHome] First load - initializing ship position based on current chapter:',
          currentChapter,
        );

        if (isFirstVisit) {
          // First visit: start ship at chapter 0, then animate to chapter 1
          console.log('[AbsolutelyHome] First visit detected - starting ship at chapter 0');
          this.shipParametric = 0; // Start at island 0
          await this.$nextTick();
          // Wait a bit for initial render
          await new Promise(resolve => setTimeout(resolve, 800));
          // Animate ship to chapter 1
          this.animateShipToChapter(1, () => {
            // Sync hasVisitedAbsolutely flag with backend after animation completes
            this.syncOnboarding({ hasVisitedAbsolutely: true });
            console.log(
              '[AbsolutelyHome] First visit animation completed - hasVisitedAbsolutely flag synced',
            );
          });
          targetChapterId = 1;
        } else {
          // Not first visit: set ship position immediately based on current chapter (FIRST LOAD ONLY)
          console.log(
            '[AbsolutelyHome] Not first visit - setting ship position to chapter:',
            currentChapter,
          );
          // Set ship position directly without animation
          this.shipParametric = Math.max(0, currentChapter - SHIP_POSITION_OFFSET);
          targetChapterId = currentChapter;

          // Set selected chapter if not already set
          if (this.selectedChapterId === 0) {
            this.setSelectedChapterId(currentChapter);
          }
        }
      } else {
        // Ship is already positioned - preserve position when navigating back
        // Only move ship if a chapter was completed (handled by query param above)
        // Don't check currentChapter here - preserve ship position
        const previousChapter = Math.round(previousShipParametric + SHIP_POSITION_OFFSET);
        console.log(
          '[AbsolutelyHome] Ship already positioned at chapter',
          previousChapter,
          '- preserving position (not checking current chapter)',
        );
        // Keep ship at its current position - don't move based on currentChapter
        // Ship will only move when a chapter is completed (via query param)
      }
    }

    // Scroll to target chapter (next chapter after completion), selected chapter, or current chapter
    const chapterToScroll = targetChapterId
      ? targetChapterId
      : this.selectedChapterId > 0
        ? this.selectedChapterId
        : this.currentChapterId;

    // Only scroll if different from prescrolled position, or if smooth scroll is needed for animation
    if (chapterToScroll !== chapterToPrescroll || targetChapterId) {
      // Wait for Ionic page transition to complete and DOM to be ready
      await this.$nextTick();
      await new Promise(resolve => setTimeout(resolve, 800));

      await this.scrollToChapter(chapterToScroll, targetChapterId ? 'smooth' : 'instant');
    }
  },
  async mounted() {
    // Add window resize listener
    window.addEventListener('resize', this.handleResize);

    // Load images (one-time setup)
    this.loadHomepageImages();
    this.loadChapterImages();
  },
  beforeUnmount() {
    // Remove window resize listener
    window.removeEventListener('resize', this.handleResize);
    // Clear any pending timeouts
    if (this.chapterConfirmTimeout) {
      clearTimeout(this.chapterConfirmTimeout);
    }
  },
};
</script>

<style scoped>
@keyframes cloud-wiggle {
  0% {
    transform: translateX(0px);
  }
  25% {
    transform: translateX(-10px);
  }
  50% {
    transform: translateX(0px);
  }
  75% {
    transform: translateX(10px);
  }
  100% {
    transform: translateX(0px);
  }
}

@keyframes cloud-wiggle-inverse {
  0% {
    transform: translateX(0px);
  }
  25% {
    transform: translateX(10px);
  }
  50% {
    transform: translateX(0px);
  }
  75% {
    transform: translateX(-10px);
  }
  100% {
    transform: translateX(0px);
  }
}

@keyframes cloud-separate {
  0% {
    transform: translateX(0px);
  }
  100% {
    transform: translateX(-30px);
  }
}

@keyframes cloud-separate-inverse {
  0% {
    transform: translateX(0px);
  }
  100% {
    transform: translateX(30px);
  }
}

@keyframes ocean-noise-wave {
  0% {
    transform: scaleY(1) scaleX(1) translateY(0px);
    filter: blur(0.5px) brightness(1);
  }
  10% {
    transform: scaleY(1.03) scaleX(1.01) translateY(-2px);
    filter: blur(0.7px) brightness(1.02);
  }
  20% {
    transform: scaleY(0.98) scaleX(1.02) translateY(2px);
    filter: blur(0.4px) brightness(0.98);
  }
  30% {
    transform: scaleY(1.01) scaleX(0.99) translateY(-1px);
    filter: blur(0.6px) brightness(1.01);
  }
  40% {
    transform: scaleY(1.02) scaleX(1.01) translateY(1px);
    filter: blur(0.8px) brightness(1.03);
  }
  50% {
    transform: scaleY(1) scaleX(1) translateY(0px);
    filter: blur(0.5px) brightness(1);
  }
  60% {
    transform: scaleY(0.97) scaleX(1.01) translateY(2px);
    filter: blur(0.6px) brightness(0.97);
  }
  70% {
    transform: scaleY(1.03) scaleX(0.98) translateY(-2px);
    filter: blur(0.7px) brightness(1.01);
  }
  80% {
    transform: scaleY(1.01) scaleX(1.02) translateY(1px);
    filter: blur(0.4px) brightness(1.02);
  }
  90% {
    transform: scaleY(0.99) scaleX(1) translateY(-1px);
    filter: blur(0.6px) brightness(0.99);
  }
  100% {
    transform: scaleY(1) scaleX(1) translateY(0px);
    filter: blur(0.5px) brightness(1);
  }
}
.ocean-noise-animate {
  animation: ocean-noise-wave 5s infinite linear;
  will-change: transform, filter;
}

.cloud-wiggle {
  animation: cloud-wiggle 2s infinite linear;
  will-change: transform;
}
.cloud-wiggle-inverse {
  animation: cloud-wiggle-inverse 2s infinite linear;
  will-change: transform;
}

.cloud-separate {
  animation: cloud-separate 1s forwards ease-in-out;
  will-change: transform;
}
.cloud-separate-inverse {
  animation: cloud-separate-inverse 1s forwards ease-in-out;
  will-change: transform;
}
</style>
